import { IncomingMessage } from 'http';
import UAParser from 'ua-parser-js';

import { CmsHelperInterface } from '../interfaces';

import { Source } from '../../../common/enums/source.enum';
import { Vertical } from '@bolttech/essentials';
import { Nullable } from '../../../common/types/nullable.type';

export class CmsHelper implements CmsHelperInterface {
  private static instance: CmsHelper;
  private _country = 'th-TH';
  private _locale = 'th';
  private _vertical: Vertical = Vertical.CarInsurance;
  private _source: Source = Source.B2C;
  private _flow = 'Direct';
  private _request: Nullable<IncomingMessage> | undefined = null;
  private _device: Nullable<string> = null;

  public static getInstance(newInstance = false): CmsHelper {
    if (newInstance || !CmsHelper.instance) {
      CmsHelper.instance = new CmsHelper();
    }

    return CmsHelper.instance;
  }

  public get locale(): string {
    return this._locale;
  }

  public get vertical(): Vertical {
    return this._vertical;
  }

  public get country(): string {
    return this._country;
  }

  public get source(): Source {
    return this._source;
  }

  public get flow(): string {
    return this._flow;
  }

  public get request(): Nullable<IncomingMessage> | undefined {
    return this._request;
  }

  public get device(): Nullable<string> {
    return this._device;
  }

  public setLocale(locale: string): CmsHelper {
    this._locale = locale;
    return this;
  }

  public setVertical(vertical: Vertical): CmsHelper {
    this._vertical = vertical;
    return this;
  }

  public setRequest(request: Nullable<IncomingMessage> | undefined): CmsHelper {
    this._request = request;
    return this;
  }

  public setCountry(country?: string): CmsHelper {
    this._country = country || this._country;
    return this;
  }

  public setDevice(device?: string): CmsHelper {
    this._device = device || (this.isMobileDevice() ? 'mobile' : 'desktop');
    return this;
  }

  public setSource(source?: Source): CmsHelper {
    this._source = source || this._source;
    return this;
  }

  public setFlow(flow?: string): CmsHelper {
    this._flow = flow || this._flow;
    return this;
  }

  private isMobileDevice(): boolean {
    const userAgent = new UAParser(this._request?.headers['user-agent']);
    const userAgentDevice = userAgent.getDevice();

    return userAgentDevice.type === 'mobile';
  }
}
